import styled from '@emotion/styled'

export const MobileWaitlistCaptureWrapper = styled.form({
  display: 'flex',
  flexWrap: 'nowrap',
  width: '100%',
})
